// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1J6xG","badges":"styles_badges__1WxSF"};